export default __webpack_public_path__ + "0a3f5e8879cd58d3bd2bdf9291eb5e0a.jpg";